 


import type { RouteObject } from 'react-router';
import { lazyRoute } from '../utils/lazyRoute';

const securityRoutes: RouteObject[] = [
  {
    path: 'NTX/*',
    children: [
      { path: 'Users', lazy: lazyRoute(() => import('../../pages/NTX/Security/Users/Users')) },

      { path: 'Users/ChangePassword', lazy: lazyRoute(() => import('../../pages/NTX/Security/Users/ChangePassword')) },

      { path: 'Users/:userId/RulesUser', lazy: lazyRoute(() => import('../../pages/NTX/Security/RulesUser/RulesUser')) },

      { path: 'Users/:refrenceId/PermissionUser', lazy: lazyRoute(() => import('../../pages/NTX/Security/Users/PermissionUser')) },

      { path: 'AuthRules/:refrenceId/PermissionRule', lazy: lazyRoute(() => import('../../pages/NTX/Security/Rules/PermissionRule')) },

      { path: 'AuthRules', lazy: lazyRoute(() => import('../../pages/NTX/Security/Rules/Index')) }
    ]
  }
];

export default securityRoutes;
